__turbopack_context__.v({
  "codeMessage": "inlineAccountCompletion-module-scss-module__SHMBDW__codeMessage",
  "codeRow": "inlineAccountCompletion-module-scss-module__SHMBDW__codeRow",
  "error": "inlineAccountCompletion-module-scss-module__SHMBDW__error",
  "field": "inlineAccountCompletion-module-scss-module__SHMBDW__field",
  "fieldHint": "inlineAccountCompletion-module-scss-module__SHMBDW__fieldHint",
  "heading": "inlineAccountCompletion-module-scss-module__SHMBDW__heading",
  "loading": "inlineAccountCompletion-module-scss-module__SHMBDW__loading",
  "row": "inlineAccountCompletion-module-scss-module__SHMBDW__row",
  "smsConsent": "inlineAccountCompletion-module-scss-module__SHMBDW__smsConsent",
  "submitButton": "inlineAccountCompletion-module-scss-module__SHMBDW__submitButton",
  "wrapper": "inlineAccountCompletion-module-scss-module__SHMBDW__wrapper",
});
